export default "__VITE_ASSET__DDgw6WxT__"